define('gameday-index-mlbtv/src/js/link',['require','exports','module','jquery','requirejs-hogan-plugin/hogan','text!../templates/mlb-tv-link.mustache','mediaLauncher/mediaLauncher','gameday-index-configurator/GamedayIndexConfigurator'],function(require,exports,module){

    var $ = require('jquery'),
        hogan = require('requirejs-hogan-plugin/hogan'),
        template = require('text!../templates/mlb-tv-link.mustache'),
        mediaLauncher = require("mediaLauncher/mediaLauncher"),
        configManager = require("gameday-index-configurator/GamedayIndexConfigurator"),
        renderLink = hogan.compile(template);

    function isPostseason(game_type){
        switch(game_type){
            case 'F':
            case 'D':
            case 'L':
            case 'W':
                return true;
            break;
        }
        return false
    }
    return {
        /**
         * Renders MLB.TV link
         */
        render : function(target) {
            var el = $(target),
                conf =  configManager.getSiteConfig();

            el.html(renderLink.render({}));
            el.off('click').on('click',function(e){
                var gameData = GDC.getGameData().linescore || {},
                    gameMedia = gameData.game_media || {},
                    data = {
                        calendar_event_id : gameMedia.calendar_event_id, 
                        // media_state : gameMedia.media_state,
                        media_type  : 'video',
                        clickOrigin : "Gameday",
                        affiliateId : ""
                    },
                    launchPlayer = (!!data.calendar_event_id && (gameMedia.media_state === "media_on" || gameMedia.media_state === "media_archive"));
                if(!launchPlayer ){
                    return true;
                }
                if(conf.sponsor){
                    data.sponsor = conf.sponsor;
                    if(data.sponsor === "CBS"){
                        data.vbID='CBSSPORTS';
                    }
                }
                e.preventDefault();
                e.stopPropagation();
                mediaLauncher.launchWithParams(data);
                return false;
            });
        },

        noLink : function( target) {
            var gameData = GDC.getGameData().linescore || {};
                data = { 
                "isPostseason" : isPostseason(gameData.game_type)
            };
        
            $(target).html(renderLink.render(data));
        }

    };

});
